import React, { useState } from 'react';
import { MessageCircle, Search } from 'lucide-react';
import { QAItem } from './QAItem';
import { AskQuestionModal } from './modals/AskQuestionModal';
interface QA {
  id: string;
  userName: string;
  userInitials: string;
  question: string;
  questionDate: string;
  answer?: {
    text: string;
    date: string;
    sellerName: string;
  };
}
interface QASectionProps {
  listingTitle: string;
  questions: QA[];
}
export function QASection({
  listingTitle,
  questions: initialQuestions
}: QASectionProps) {
  const [isAskQuestionOpen, setIsAskQuestionOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const filteredQuestions = initialQuestions.filter(qa => qa.question.toLowerCase().includes(searchQuery.toLowerCase()) || qa.answer?.text.toLowerCase().includes(searchQuery.toLowerCase()));
  return <div className="space-y-6" data-id="element-1001">
      <div className="bg-white border border-gray-300 p-6" data-id="element-1002">
        <div className="flex items-center justify-between mb-4" data-id="element-1003">
          <h2 className="text-2xl font-bold flex items-center gap-2" data-id="element-1004">
            <MessageCircle className="w-6 h-6" data-id="element-1005" />
            Questions & Answers
          </h2>
          <button onClick={() => setIsAskQuestionOpen(true)} className="px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-1006">
            Ask Question
          </button>
        </div>

        <p className="text-sm text-gray-600 mb-4" data-id="element-1007">
          Have a question about this property? Ask the seller directly.
        </p>

        {/* Search */}
        <div className="relative" data-id="element-1008">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" data-id="element-1009" />
          <input type="text" placeholder="Search questions and answers..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500 text-sm" data-id="element-1010" />
        </div>
      </div>

      {/* Questions List */}
      <div className="space-y-4" data-id="element-1011">
        {filteredQuestions.length > 0 ? filteredQuestions.map(qa => <QAItem key={qa.id} {...qa} data-id="element-1012" />) : <div className="bg-white border border-gray-300 p-12 text-center" data-id="element-1013">
            <MessageCircle className="w-12 h-12 text-gray-300 mx-auto mb-4" data-id="element-1014" />
            <p className="text-gray-500 font-mono mb-4" data-id="element-1015">
              {searchQuery ? 'No questions match your search' : 'No questions yet'}
            </p>
            <button onClick={() => setIsAskQuestionOpen(true)} className="px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-1016">
              Be the First to Ask
            </button>
          </div>}
      </div>

      <AskQuestionModal isOpen={isAskQuestionOpen} onClose={() => setIsAskQuestionOpen(false)} listingTitle={listingTitle} data-id="element-1017" />
    </div>;
}